// Qué falta para poder prestar la firma · Escala Fase E3.
//
// =====================================================================
// LO QUE DE VERDAD SE PRUEBA AQUI
// =====================================================================
// No es que salga la lista de lo que falta: es que diga **lo mismo que
// el servidor**. Estas cuatro reglas viven también en
// `backend/app/escala/reglas.py:delegar` y en la migración 367, y si
// discreparan habría un botón que parece listo y un error al pulsarlo —
// que es peor que no validar nada, porque enseña a desconfiar del botón.
//
// Por eso están aquí, en un módulo aparte y sin React: una regla metida
// dentro de un componente no se puede comparar con la del servidor sin
// montar la pantalla entera.
//
// EL TOPE ES 180 DIAS y está en tres sitios a propósito: aquí para poder
// avisar **antes** de guardar —prevenir en vez de regañar—, en el
// endpoint para que ningún otro camino lo salte, y en la base
// (`delegacion_no_eterna`) para el día que haya un guion de carga.

export const TOPE_DIAS = 180;

/**
 * Lo que impide prestar la firma, o cadena vacía si no falta nada.
 *
 * Devuelve UNA sola frase y no una lista, y es deliberado: el botón
 * enseña debajo por qué está deshabilitado, y tres motivos a la vez
 * obligan a leer para saber cuál arreglar primero. Se dicen en el orden
 * en que se rellena el formulario, así que siempre es el siguiente hueco.
 */
export function loQueFaltaParaPrestar({ aQuien, permiso, desde, hasta,
                                        motivo }) {
  if (!aQuien) return 'Elige a quién le prestas tu firma.';
  if (!permiso) return 'Elige qué le prestas.';
  if (!hasta) {
    return 'Pon hasta qué día. Es obligatorio: una delegación sin fecha '
         + 'de fin es un cambio de permisos que nadie revisa.';
  }

  const dias = diasEntre(desde, hasta);
  if (dias === null) return 'Revisa las fechas.';
  if (dias < 0) return 'La fecha de fin es anterior a la de inicio.';
  if (dias > TOPE_DIAS) {
    // Y DICE QUE HACER EN SU LUGAR, no solo que no se puede. Si hace
    // falta más tiempo que eso, lo que se necesita no es prestar una
    // firma: es cambiarle los permisos a esa persona.
    return `Son ${dias} días y el máximo son ${TOPE_DIAS}. Si necesitas `
         + 'más tiempo, lo que hace falta es cambiarle los permisos a esa '
         + 'persona desde su ficha.';
  }

  if ((motivo || '').trim().length < 4) {
    return 'Escribe por qué: «vacaciones», «viaje». Es lo que dentro de '
         + 'seis meses explicará una firma.';
  }
  return '';
}

/** Días entre dos fechas `YYYY-MM-DD`, o `null` si alguna no vale. */
export function diasEntre(desde, hasta) {
  if (!desde || !hasta) return null;
  const a = Date.parse(`${desde}T00:00:00Z`);
  const b = Date.parse(`${hasta}T00:00:00Z`);
  if (Number.isNaN(a) || Number.isNaN(b)) return null;
  // EN UTC Y A MEDIANOCHE, no con `new Date(fecha)` a secas: con la hora
  // local, un cambio de horario de verano mete o quita una hora y una
  // delegación de exactamente 180 días sale de 179 o de 181 según el mes.
  return Math.round((b - a) / 86400000);
}
